import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
const boxClasses = generateUtilityClasses('MuiBox', ['root']);
export default boxClasses;


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/Box/boxClasses.js
// module id = 440
// module chunks = 25